module.exports = __webpack_public_path__ + "static/national-college-logo-82ebec3faf42c243cac13c8130765214.png";